export default "__VITE_ASSET__DBQsS5YY__"